import { gaEvent } from '~/plugins/gtagGA4'
const initialState = {
  counter: 0,
  session: {},
  cookies: {},
  user: null,
  handlUser: null,
  authToken: null,
  soundcloudProvider: {},
  spotifyProvider: {},
  scClient: { client_id: '', redirect_uri: '' },
  featured: '628530f718ce7c0004242c41', // sound bath
  localPolygon: { entryFile: '', blobUrls: {} },
  hasEnteredGeofence: false,
  selectedSet: '',
  dropsLogo: 'https://wox-drops.s3.amazonaws.com/img/DropsLogo.png',
  photoframe: 'https://wox-drops.s3.amazonaws.com/img/photoframe.png',
  // photoframe: 'https://wox-drops.s3.amazonaws.com/img/drops/zed/habillagestatique-ZED-MALCOM.png',
  drop: {
    // { index: 1, id: 'edit', name: 'Edit' }
    keyframes: [],
    camera: {
      props: {
        positionX: 0,
        positionY: 9,
        positionZ: 0
      }
    },
    droplet: { rotate: true, scale: 1 },
    polygon: { rotate: true, scale: 1, material: { override: false } },
    video: undefined,
    preview: false,
    track: undefined,
    isGeofenced: false,
    showWrapper: true,
    portal: {
      visible: false,
      polygon: {
        file: 'portalPolygon_default.glb'
      },
      rim: {
        file: 'portalRim_default.glb'
      },
      light: {
        file: 'portalLight_default.glb'
      },
      ground: {
        file: 'portalGround_default.glb'
      },
      skyboxImg: {
        name: 'galaxy',
        description: 'portal sky',
        relativePath: 'skybox/milkyway_galaxy_sphere_map_2048w.jpeg'
      }
    },
    point: { coords: [0, 0], radius: 100, message: '' },
    preMessage:
      'This is the message people will see before they open your drop.',
    // TODO: refactor me to use props like rewards
    messageProps: {
      background: '#FFFFFF',
      text: '#000000',
      fontSize: 10,
      wrapCount: 20,
      positionX: -10,
      positionY: 6,
      positionZ: -11,
      rotation: 10,
      height: 3,
      width: 3,
      asHotspot: false
    },
    rewards: [],
    // reward: {},
    // post message
    altDropId: '',
    launchDate: '',
    parentSet: '',
    privacyType: 'private',
    version: 2.0,
    thumbnail: { file: 'https://wox-drops.s3.amazonaws.com/img/DropsLogo.png' },
    title: '',
    hasErrors: false,
    errors: {}
  },
  defaultReward: {
    title: '',
    message:
      "Here's where you can add some text for when users are in your drop! Or remove it to make this box go away.",
    badge: '',
    url: '',
    play: undefined,
    props: {
      background: '#00ffff',
      text: '#000000',
      fontSize: 10,
      wrapCount: 20,
      positionX: -10,
      positionY: 6,
      positionZ: -11,
      rotation: 10,
      height: 3,
      width: 3,
      depth: 1,
      asHotspot: false
    }
  },
  polygons: [],
  playlist: [],
  keyframe: { index: 1, isReady: false }, // state (keyframe) used in the create screen
  templates: [
    // {
    //   id: '1', // drop _id to clone
    //   title: 'Valentines Day',
    //   image: '',
    //   body: 'A valentines day heart'
    // },
    {
      id: '1', // drop _id to clone
      title: 'Happy Birthday',
      image: '',
      body: "Send a cake, it's easier than baking"
    },
    {
      id: '2',
      title: 'Air Hug',
      image: '',
      body: 'Give someone a socially distanced hug'
    }
  ],
  canvas: { width: 0, height: 0 }
}

// do we need this?
const cookieParser = process.server ? require('cookieparser') : undefined

export const state = () => ({ ...initialState })

export const mutations = {
  resetState (state) {
    this.$cookies.remove('user')
    this.$cookies.remove('handleUser')
    this.$cookies.remove('token')
    this.$cookies.removeAll()

    Object.assign(state, initialState)
  },
  resetDropState (state) {
    state.drop = Object.keys(state.drop)
      .filter(key => !['_id', '__v'].includes(key))
      .reduce((obj, key) => {
        return {
          ...obj,
          [key]: state.drop[key]
        }
      }, {})

    Object.assign(state.drop, initialState.drop)

    state.drop.droplet = {
      name: 'default',
      rotate: true,
      formats: [
        {
          formatType: 'GLB',
          root: {
            contentType: 'model/gltf+json',
            url: 'gltf/audiodrop1.glb'
          }
        }
      ]
    }
  },
  resetUserState (state) {
    state.user = null
  },
  increment (state) {
    state.counter++
  },
  session (state, n) {
    state.session = n
  },
  cookies (state, n) {
    state.cookies = n
  },
  user (state, n) {
    state.user = n
    // set SpotifyProvider
    if (state.user.providers) {
      state.user.providers.forEach((provider) => {
        if (provider.providerType === 'spotify') {
          state.spotifyProvider = provider
        } else if (provider.providerType === 'soundcloud') {
          state.soundcloudProvider = provider
        }
      })
    }
  },
  handleUser (state, n) {
    state.handleUser = n
  },
  authToken (state, n) {
    state.authToken = n
  },
  scClient (state, n) {
    state.scClient = n
  },
  addSet (state, n) {
    state.user.sets.push(n)
  },
  selectedSet (state, n) {
    state.selectedSet = n
  },
  updateMySet (state, n) {
    state.user.my_set = n
  },
  drop (state, n) {
    state.drop = { ...state.drop }
    const keys = Object.keys(n)
    keys.forEach((key) => {
      state.drop[key] = n[key]
    })
  },
  enterGeofence (state, n) {
    state.hasEnteredGeofence = n
  },
  keyframe (state, n) {
    state.keyframe = { ...state.keyframe }
    const keys = Object.keys(n)
    keys.forEach((key) => {
      state.keyframe[key] = n[key]
    })
  },
  localPolygon (state, n) {
    state.localPolygon = n

    const { _id, __v, ...newPoly } = state.drop.polygon
    const keys = Object.keys(n)
    keys.forEach((key) => {
      newPoly[key] = n[key]
    })

    const format = {
      formatType: 'GLTF',
      root: {
        contentType: 'model/gltf+json',
        relativePath: 'scene.gltf',
        url: n.entryFile
      }
    }
    newPoly.formats = [format]

    state.drop.polygon = newPoly
  },
  poly (state, n) {
    if (state.drop.polygon) {
      const { _id, __v, ...newPoly } = state.drop.polygon
      const keys = Object.keys(n)
      keys.forEach((key) => {
        newPoly[key] = n[key]
      })

      state.drop.polygon = newPoly
    }
  },
  camera (state, n) {
    state.drop.camera = { ...state.drop.camera }
    const keys = Object.keys(n)
    keys.forEach((key) => {
      state.drop.camera.props[key] = n[key]
    })
  },
  polygons (state, n) {
    if (state.polygons) {
      state.polygons = n
    }
  },
  polySize (state, n) {
    state.drop.polygon = { ...state.drop.polygon }
    state.drop.polygon.size = n
  },
  playlist (state, n) {
    state.playlist = n
  },
  track (state, n) {
    const keys = Object.keys(n)
    if (state.drop.track) {
      const { _id, __v, ...newTrack } = state.drop.track
      keys.forEach((key) => {
        newTrack[key] = n[key]
      })

      state.drop.track = newTrack
    } else {
      state.drop.track = { ...state.drop.track }
      keys.forEach((key) => {
        state.drop.track[key] = n[key]
      })
    }
  },
  deletePolygon (state) {
    state.drop.polygon = null
  },
  deleteTrack (state) {
    state.drop.track = undefined
  },
  deletePortal (state) {
    state.drop.portal = undefined
  },
  wrapper (state, n) {
    const { _id, __v, ...newWrapper } = state.drop.droplet
    const keys = Object.keys(n)
    keys.forEach((key) => {
      newWrapper[key] = n[key]
    })

    state.drop.droplet = newWrapper
  },
  title (state, n) {
    state.drop.title = n
  },
  thumbnail (state, n) {
    debugger
    state.drop.thumbnail = n
  },
  preMessage (state, n) {
    state.drop.preMessage = n
  },
  isGeofenced (state, n) {
    state.drop.isGeofenced = n
  },
  portal (state, n) {
    const keys = Object.keys(n)
    debugger
    if (state.drop.portal) {
      const { _id, __v, ...newPortal } = state.drop.portal
      newPortal[n.key] = n.value
      state.drop.portal = newPortal
    } else {
      // do i need this?
      state.drop.portal = { ...state.drop.portal }
      keys.forEach((key) => {
        state.drop.portal[key] = n[key]
      })
    }
  },
  altDropId (state, n) {
    state.drop.altDropId = n
  },
  launchDate (state, n) {
    state.drop.launchDate = n
  },
  video (state, n) {
    const keys = Object.keys(n)
    if (state.drop.video) {
      const { _id, __v, ...newVideo } = state.drop.video
      keys.forEach((key) => {
        newVideo[key] = n[key]
      })

      state.drop.video = newVideo
    } else {
      state.drop.video = { ...state.drop.video }
      keys.forEach((key) => {
        state.drop.video[key] = n[key]
      })
    }
  },
  addReward (state, n) {
    debugger
    state.drop.rewards.push(n)
    return state.drop.rewards.length - 1
  },
  getRewardByIndex (state, index) {
    return state.drop.rewards[index]
  },
  updateRewards (state, n) {
    state.drop.rewards[n.index] = n.value
  },
  rewards (state, n) {
    state.drop.rewards[n.index] = Object.keys(state.drop.rewards[n.index])
      // .filter(key => !['_id', '__v'].includes(key))
      .reduce((obj, key) => {
        return {
          ...obj,
          [key]: state.drop.rewards[n.index][key]
        }
      }, {})
    state.drop.rewards[n.index][n.key] = n.value
  },
  //
  messageProps (state, n) {
    state.drop.rewards[n.index].props = Object.keys(state.drop.rewards[n.index].props)
    // test dont remove _id...
    // .filter(key => !['_id', '__v'].includes(key))
      .reduce((obj, key) => {
        return {
          ...obj,
          [key]: state.drop.rewards[n.index].props[key]
        }
      }, {})
    state.drop.rewards[n.index].props[n.key] = n.value
  },
  point (state, n) {
    state.drop.point = Object.keys(state.drop.point)
      .filter(key => !['_id', '__v'].includes(key))
      .reduce((obj, key) => {
        return {
          ...obj,
          [key]: state.drop.point[key]
        }
      }, {})

    if (n.key === 'coords') {
      state.drop.point[n.key][n.index] = n.value
    } else {
      state.drop.point[n.key] = n.value
    }
  },
  // pointMessage(state, n) {
  //   state.drop.point.message = n
  // },
  dropErrors (state, n) {
    state.drop = { ...state.drop }
    state.drop.hasErrors = n.hasErrors
    state.drop.errors = n.errors
  },
  canvas (state, n) {
    state.canvas = n
  },
  spotifyProvider (state, n) {
    state.spotifyProvider = { ...state.spotifyProvider }
    if (state.spotifyProvider) {
      state.spotifyProvider.id = state.spotifyProvider._id // impt for saving on server

      if (n.access_token) {
        state.spotifyProvider.token = n.access_token
        state.spotifyProvider.access_token = n.access_token // impt for saving on server
      }

      if (n.refresh_token) {
        state.spotifyProvider.refresh_token = n.refresh_token // impt for saving on server
      }

      if (state.loggedInUser) {
        state.spotifyProvider.user = state.loggedInUser._id
      }

      state.spotifyProvider.expirationDate = new Date(
        new Date().getTime() + n.expires_in * 1000
      )
    }
    if (state.user.strategy === 'spotify') {
      state.user = { ...state.user }
      state.user.oauth_token = n.access_token
    }
  }
}
export const getters = {
  isAuthenticated (state) {
    return !!state.authToken
  },
  getPoly: (state) => {
    state.drop.polygon.formats.forEach((format, formatindex) => {
      // arr.push(value);
      if (
        format.formatType === 'GLB' ||
        format.formatType === 'GLTF' ||
        format.formatType === 'GLTF2'
      ) {
        if (format.root.contentType === 'model/gltf+json') {
          return format.root.url
        }
      }
    })
  },
  getInitialState () {
    return initialState.drop
  }
}

export const actions = {
  nuxtServerInit ({ commit }, { req }) {},

  async recordAndReward ({ commit, state }) {
    // /recordDrop
    try {
      // don't record when creating in /new
      if (state.drop._id) {
        gaEvent({
          event: 'drop_unlocked',
          params: {
            drop_id: state.drop._id
          }
        })
        const response = await this.$axios.post('/recordDrop', {
          userid: state.user ? state.user._id : '',
          dropid: state.drop._id
        })
        if (response.data && response.data.reward) {
          commit('reward', response.data.reward)
        }
        // console.log('response ' + response)
        return true
      }
    } catch (error) {
      // console.log('errror' + error)
      return error
    }
  },
  async recordLink ({ commit, state }) {
    // /recordLink
    try {
      // don't record when creating in /new
      if (state.drop._id && state.drop.reward) {
        const response = await this.$axios.post(
          `https://${window.location.hostname}/recordLink`,
          {
            rewardid: state.drop.reward._id
          }
        )
        // console.log('response ' + response)
        return true
      }
    } catch (error) {
      // console.log('errror' + error)
      return error
    }
  }
}
